// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_1ZAxC","informationWrap":"informationWrap_odJm7","information":"information_2kDhg","title":"title_3cFtA","description":"description_2ktNx","link":"link_2TCia"};